module.exports = __webpack_public_path__ + "static/media/emailDark.abf52af6.svg";